import { render, staticRenderFns } from "./companyDetail.vue?vue&type=template&id=14a554d2&scoped=true"
import script from "./companyDetail.vue?vue&type=script&lang=js"
export * from "./companyDetail.vue?vue&type=script&lang=js"
import style0 from "./companyDetail.vue?vue&type=style&index=0&id=14a554d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a554d2",
  null
  
)

export default component.exports